import { SVGProps, Ref, forwardRef } from 'react';

export const FunnelOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 5V2h22v3l-8 11v6H9v-6zm9.8 10.415V20.2h2.4v-4.785l8-11V3.8H2.8v.615z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FunnelOutlinedSize24Glyph.displayName = 'FunnelOutlinedSize24Glyph';
